import { render, staticRenderFns } from "./pages17.vue?vue&type=template&id=c8379d8c&scoped=true&"
import script from "./pages17.vue?vue&type=script&lang=js&"
export * from "./pages17.vue?vue&type=script&lang=js&"
import style0 from "./pages17.vue?vue&type=style&index=0&id=c8379d8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8379d8c",
  null
  
)

export default component.exports